import { render, staticRenderFns } from "./AuthorContactUs.vue?vue&type=template&id=7ab5f8b4&scoped=true&"
import script from "./AuthorContactUs.vue?vue&type=script&lang=js&"
export * from "./AuthorContactUs.vue?vue&type=script&lang=js&"
import style0 from "./AuthorContactUs.vue?vue&type=style&index=0&id=7ab5f8b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5f8b4",
  null
  
)

export default component.exports